// C:\Helpdesk\frontend\src\layout\MainLayout\Topbar\UserMenu.js
import React from 'react';
import { User, Settings, LogOut } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../layout.css';

const UserMenu = ({ user, onClose }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
    onClose();
  };

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  return (
    <div className="user-menu-container">
      <div className="user-menu-header">
        <div className="user-avatar">
          <User size={40} />
        </div>
        <div className="user-info">
          <h4 className="user-name">{user.name || 'User'}</h4>
          <p className="user-email">{user.email}</p>
          <p className="user-role">{user.role_name}</p>
        </div>
      </div>

      <div className="user-menu-items">
        <button 
          className="menu-item"
          onClick={() => handleNavigation('/profile')}
        >
          <User className="menu-icon" size={16} />
          <span>My Profile</span>
        </button>

        <div className="menu-divider"></div>

        <button 
          className="menu-item logout"
          onClick={handleLogout}
        >
          <LogOut className="menu-icon" size={16} />
          <span>Sign out</span>
        </button>
      </div>
    </div>
  );
};

export default UserMenu;